import Image from "next/image";
import React from "react";

interface ServiceCardProps {
  imagePath: string;
  isButton: boolean;
  url: string;
  logoWidth: number;
  logoHeight: number;
}

function ServiceCard({
  imagePath,
  isButton,
  url,
  logoWidth,
  logoHeight,
}: ServiceCardProps): React.JSX.Element {
  return (
    <a
      href={`${url}`}
      className={`h-[80px] w-[150px] overflow-hidden rounded bg-white-100 shadow-lg transition duration-300 ease-in-out hover:scale-110 sm:h-[95px] sm:w-[260px] ${isButton ? "" : "pointer-events-none"}`}
    >
      <div className="mt-5 flex justify-center align-middle">
        <Image
          src={require(`/public/images/aiOptOut/${imagePath}`)}
          alt={imagePath}
          className=""
          width={logoWidth}
          height={logoHeight}
          priority
        />
      </div>
    </a>
  );
}

export default ServiceCard;
